import devMode from '@/devMode.js'

const urlConfig = {
  rideqMain: 'https://europe-west1-rideq-main.cloudfunctions.net',
  rideqEmail: 'https://europe-west1-rideq-main.cloudfunctions.net', // 'https://europe-west1-rideq-email.cloudfunctions.net',
  rideqData: 'https://europe-west1-rideq-data.cloudfunctions.net'
}

if (devMode.devDatabase === true) {
  urlConfig.rideqMain = 'https://europe-west1-rideq-dev.cloudfunctions.net'
}

export default urlConfig
